// extracted by mini-css-extract-plugin
module.exports = {"filterItemContainer":"SearchDropdown_filterItemContainer__3efz6","filterType":"SearchDropdown_filterType__2tvoY","closeIcon":"SearchDropdown_closeIcon__3YIkk"};